import {
  parseAsBoolean,
  parseAsIsoDate,
  parseAsString,
  parseAsStringEnum,
  useQueryStates,
} from 'nuqs'

import { Gender } from '@/common/models/person'
import { UserType } from '@/common/models/user'

export function useFilterUsers() {
  return useQueryStates({
    freeSearch: parseAsString,
    userType: parseAsStringEnum(Object.values(UserType)),
    gender: parseAsStringEnum(Object.values(Gender)),
    birthMonth: parseAsString,
    birthYear: parseAsString,
    startCreated: parseAsIsoDate,
    endCreated: parseAsIsoDate,
    isActive: parseAsBoolean.withDefault(false),
  })
}
